import parse from 'html-react-parser';

const HtmlContent = ({rawHtml}) =>
    <>
        {rawHtml ? parse(rawHtml) : ''}
    </>

export default HtmlContent